// tslint:disable-next-line:no-var-requires
require('ui-common/polyfills/customEvent');

import 'usertiming'; // polyfill performance.now
import 'formdata-polyfill'; // polyfill FormData
import * as ReactDOM from 'react-dom';
import 'login-stylesheets/global';
import './index.scss';
import '@blend/shared-react/assets/blend-icons.css';
import { utils } from '@blend/ui-common';
import { initTracking } from '@blend/frontend-tracking';
import * as globalWrappers from 'login-utils/globalWrappers';
import * as userUtils from 'login-utils/userUtils';
import * as pixelUtils from 'login-utils/pixelUtils';
import routeConfiguration from './routeConfig';

initTracking(pixelUtils.trackV2);

const { sentryConfig } = utils;

sentryConfig.initialize({
  dsn: 'https://835c5faabdfc4a0bbf97e17db2a3cee2@sentry-proxy.k8s.tools.blend.com/37',
  release: globalWrappers.getWindow().APP_VERSION,
});

const currentUser = userUtils.getCurrentUser();
if (currentUser) {
  sentryConfig.setUserContext(userUtils.getLoggableUser(currentUser));
}

ReactDOM.render(routeConfiguration, document.getElementById('root'));
